import React from 'react';
import { useForm } from '../../context/FormContext';
import { cn } from '../../lib/utils';

const ProgressIndicator: React.FC = () => {
  const { currentPage, totalPages } = useForm();
  
  // Create an array of page numbers for the indicator
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);
  
  return (
    <div className="mb-8">
      <div className="flex items-center justify-center">
        {pages.map((page, index) => {
          // Use a wrapper div instead of Fragment to avoid issues with unwanted props
          return (
            <div key={page} className="contents">
              {/* Page indicator */}
              <div className="flex flex-col items-center">
                <div 
                  className={cn(
                    "h-10 w-10 rounded-full flex items-center justify-center border-2",
                    page === currentPage 
                      ? "bg-form-blue text-white border-form-blue" 
                      : page < currentPage 
                        ? "bg-form-light-blue text-white border-form-light-blue" 
                        : "bg-white text-gray-500 border-gray-300"
                  )}
                >
                  {page}
                </div>
                <span className="text-xs mt-1">หน้า {page}</span>
              </div>
              
              {/* Line between indicators */}
              {index < pages.length - 1 && (
                <div 
                  className={cn(
                    "h-1 flex-1 mx-2",
                    page < currentPage ? "bg-form-light-blue" : "bg-gray-300"
                  )}
                ></div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressIndicator;
